// eslint-disable-next-line
import React, { useMemo, useState } from 'react'
import axios from 'axios'
import { getLocationDevicesAmount } from '../../../utils'

export const useLocationsDevicesAmount = searchString => {
    const [devicesAmountMap, setDevicesAmountMap] = useState(null)
    const [locationsDevicesAmountMap, setLocationsDevicesAmountMap] =
        useState(null)
    const [isLoadingDevicesAmountMap, setIsLoadingDevicesAmountMap] =
        useState(false)

    useMemo(async () => {
        if (typeof searchString === 'string' && searchString.length > 0) {
            try {
                setIsLoadingDevicesAmountMap(true)
                const allLocations = (
                    await axios.get(`${process.env.API_URL}/locations`)
                ).data
                const maps = allLocations.reduce(
                    (acc, l) => {
                        acc.newDevicesAmountMap[l.id] =
                            getLocationDevicesAmount(l)
                        acc.newLocationsDevicesAmountMap[l.id] = l
                        return acc
                    },
                    {
                        newDevicesAmountMap: {},
                        newLocationsDevicesAmountMap: {}
                    }
                )
                setDevicesAmountMap(maps.newDevicesAmountMap)
                setLocationsDevicesAmountMap(maps.newLocationsDevicesAmountMap)
                setIsLoadingDevicesAmountMap(false)
            } catch (ex) {
                setIsLoadingDevicesAmountMap(false)
            }
        }
    }, [searchString])

    return {
        devicesAmountMap,
        locationsDevicesAmountMap,
        isLoadingDevicesAmountMap
    }
}
